<template src="./DeliveryKiotvietDetailComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {ref, computed, reactive, onMounted, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import {AppConstant, AlertText} from "@/supports/app.constant";
import {ConfirmText, ErrorText} from "@/supports/error-message.constant";
import InputNumberComponent from "@/components/inputs/input-number/InputNumberComponent.vue";
import {useRoute, useRouter} from "vue-router";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import ModalDeliveryCommentComponent
  from "@/components/modals/modal-delivery-comment/ModalDeliveryCommentComponent.vue";
import IconComment from "@/components/icons/IconComment.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import {useUserStore} from "@/stores/users.js";
import AlertWarningComponent from "@/components/alerts/alert-warning/AlertWarningComponent.vue";
import ButtonRejectComponent from "@/components/buttons/button-reject/ButtonRejectComponent.vue";
import {useSyncKiotviet} from "@/stores/syncKiotviet.js";
export default {
  name: 'DeliveryKiotvietDetailComponent',
  components: {
    ButtonRejectComponent,
    AlertWarningComponent,
    InputDateTimeNormal,
    IconComment,
    ModalDeliveryCommentComponent,
    InputCheckboxOne,
    InputNumberComponent,
    LoadingComponent,
    ModalDeliveryProductListComponent,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const errors = ref(true)
    const dataExchangeDelivery = ref({
      exchange_delivery_name: {
        id: 'exchange_delivery_name',
        label: 'Tên phiếu giao hàng',
        placeholder: 'Tên phiếu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        disabled: false,
      },
      partner_id: {
        id: 'partner_id',
        label: 'Đối tác giao hàng',
        placeholder: 'Đối tác giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false,
        options: []
      },
    })
    const dataHeaderTable = ref({
      product_name: {
        label: 'Tên sản phẩm',
        order: 2,
        width: '15%',
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 3,
        width: '10%',
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 4,
        width: '10%',
      },
      product_quantity: {
        label: 'Số lượng',
        order: 5,
        width: '10%',
      },
      product_tax: {
        label: 'Thuế (%)',
        order: 6,
        width: '10%',
      },
      product_unit: {
        label: 'Đơn vị',
        order: 7,
        width: '10%',
      },
      product_total_origin: {
        label: 'Giá chưa tính thuế',
        order: 8,
        width: '12.5%',
      },
      product_total: {
        label: 'Tổng tiền',
        order: 9,
        width: '12.5%',
      },
    })
    const listProductsSelected = ref([])
    const labelSelectProduct = ref('Chọn sản phẩm')
    const eventClickShowModal = ref(false)
    const eventClickShowModalComment = ref(false)
    const isLoading = ref(false)
    const totalPrice = ref(0)
    const totalPriceWithTax = ref(0)
    const deliveryId = ref(0)
    const partnerId = ref(0)
    const partnerDelivery = ref(null)
    const delivery = ref({})
    const heightComment = ref('300px')
    const accountComment = ref({
      company_name: '',
      logo: '',
      user_name: '',
    })
    const disableFields = ref(false)
    const isReject = ref(false)
    const type = ref(1)
    const route = useRoute()
    const router = useRouter()
    const syncKiotvietStore = useSyncKiotviet()
    const accountStore = useAccountStore()

    onMounted(() => {
      getListPartner();
      getDeliveryDetail(route.query.delivery_code, route.query.m_company_id, route.query.partner_select_id);
    })

    // listen change list partner
    const listPartners = computed(() => {
      return syncKiotvietStore.data_partners;
    });

    watch(() => syncKiotvietStore.datas, (newListMasterDelivery) => {
      if (!newListMasterDelivery) {
        router.push({ name: '404'})
      }

      totalPrice.value = syncKiotvietStore.datas.sum_amount;
      totalPriceWithTax.value = syncKiotvietStore.datas.sum_tax_amount;
      delivery.value = newListMasterDelivery
      dataExchangeDelivery.value.exchange_delivery_name.value = newListMasterDelivery.exchange_delivery_name
      dataExchangeDelivery.value.partner_id.value = newListMasterDelivery.kiotviet_partner_id
      partnerId.value = dataExchangeDelivery.value.partner_id.value
      partnerDelivery.value = listPartners.value.find((partner) => parseInt(partner.kiotviet_partner_id) === parseInt(partnerId.value));

      listProductsSelected.value = newListMasterDelivery.details
      listProductsSelected.value.forEach((product) => {
        product.total_price_origin = product.product_price * product.product_quantity;
        product.total_price_tax = (1 + parseInt(product.tax_rate)/100) * product.total_price_origin;
      });
      deliveryId.value = newListMasterDelivery.delivery_code
      dataExchangeDelivery.value.exchange_delivery_name.disabled = true
      dataExchangeDelivery.value.partner_id.disabled = true
      disableFields.value = true
    });

    // call api list partner
    async function getListPartner() {
      const params = {
        m_company_id: accountStore.account.company.id
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/get-partner-sync-connected';
      await syncKiotvietStore.getListPartnerSyncKiotvietConnected(url, params);

      syncKiotvietStore.data_partners.forEach((partner) => {
        dataExchangeDelivery.value.partner_id.options.push({
          name: partner.partner_name,
          value: partner.kiotviet_partner_id
        })
      })
    }

    async function getDeliveryDetail(delivery_code, m_company_id, partner_select_id) {
      const params = {
        delivery_code: delivery_code,
        m_company_id: m_company_id,
        kiotviet_partner_id: partner_select_id
      }

      const url = AppConstant.URL_API_LOCAL + 'api/v1/sync-kiotviet/get-delivery-kiotviet-detail';
      return await syncKiotvietStore.getlistDataDeliveryDetail(url, params);
    }

    return {
      delivery,
      deliveryId,
      partnerId,
      totalPrice,
      dataExchangeDelivery,
      labelSelectProduct,
      dataHeaderTable,
      isLoading,
      eventClickShowModal,
      errors,
      heightComment,
      eventClickShowModalComment,
      accountComment,
      disableFields,
      isReject,
      totalPriceWithTax,
      type,
      partnerDelivery,
      AppConstant,
      CommonService,
      AlertText,
      listProductsSelected
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
        .comments {
          border-radius: 10px;
          border: 1px solid #d9dee3;
          overflow-y: scroll;
          ::-webkit-scrollbar {
            width: 10px;
          }
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
          ::-webkit-scrollbar-thumb {
            background: #888;
          }
          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .no_comments {
            height: 80%;
          }
          .create_comment {
            height: 20%;
          }
          .list_comments {
            .comment {
              .info {
                .name {
                  .company, .user {
                    border: 1px solid #000;
                    border-radius: 20px;
                    padding: 5px 10px
                  }
                }
              }
              .content {
                padding: 10px;
              }
            }
            .part {
              border-top: 1px solid #000;
              margin: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
